import { render, staticRenderFns } from "./set-up.vue?vue&type=template&id=7532f99e&scoped=true"
import script from "./set-up.vue?vue&type=script&lang=js"
export * from "./set-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532f99e",
  null
  
)

export default component.exports